import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { LicenseDeleteComponent } from '../../modals/license-delete/license-delete.component';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { VoucherEdit } from '../../classes';
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EventsService } from 'src/app/services/events/events.service';

declare var moment: any;

@Component({
  selector: 'app-license-edit',
  templateUrl: './license-edit.component.html',
  styleUrls: ['./license-edit.component.less']
})
export class LicenseEditComponent implements OnInit {
  public licenseEditForm;
  @Input() license;

  constructor(private ngbModal: NgbModal, private fb: FormBuilder, private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService,
    private events: EventsService, private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.initlicenseEdit();
  }

  // inits form
  private initlicenseEdit() {
    this.licenseEditForm = this.fb.group({
        first_name:[this.license.data.first_name, [Validators.required]],
        last_name:[this.license.data.last_name, [Validators.required]],
        organization : [this.license.data.organization,[Validators.required]],
        email : [this.license.data.email,[Validators.required]],
        phone : [this.license.data.phone,[Validators.required]],
        expired_date : [moment(this.license.data.expired_date).format('YYYY-MM-DD')],
        app_version : [this.license.data.app_version,[Validators.required]]
     });
  }

  // trigger delete license 
  public triggerDeleteLicenseModal() {
    const modal = this.ngbModal.open(LicenseDeleteComponent);

    modal.componentInstance.licenseDetails = this.license;

    modal.result
      .then((msg) => {
        if (msg.success) {
          const userid = msg.user;

          this.activeModal.close({ user: userid, task: 'close modal', success: true });
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // update license
  public updateLicense() {
      let obj = {
         id : this.license.data.id,
         first_name : this.licenseEditForm.value.first_name,
         last_name : this.licenseEditForm.value.last_name,
         organization : this.licenseEditForm.value.organization,
         email : this.licenseEditForm.value.email,
         phone : this.licenseEditForm.value.phone,
         app_version : this.licenseEditForm.value.app_version,
         expired_date : this.licenseEditForm.value.expired_date
       }

       this.admin.updateLicense(obj)
       .then(res => this.success(res, obj))
       .catch(err => this.error(err));
   }

   // handle success
   private success(msg, license) {
     // get voucher id
     const from = this.license.from;
     const id = this.license.data.id;

     this.msg.success(msg);
     this.events.triggerTableReload(id, from, 'update', license);
     this.activeModal.close({ user: id, task: 'update', success: true });
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }
}
